exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chooseRoom .el-cascader {\n  width: calc(100% - 234px);\n}\n", ""]);

// exports
